import { type ReactElement } from 'react';
import type { OrderDto } from '@/shared/api/order';
import IconCancelled from '@/shared/assets/IconCancelled.react.svg';
import IconSuccess from '@/shared/assets/IconSuccess.react.svg';

export const getCheckoutFeedbackIcon = (order: OrderDto): ReactElement => {
    if (order.status === 'CANCELLED') {
        return <IconCancelled />;
    }

    return <IconSuccess />;
};
